import { render, staticRenderFns } from "./ThemePreview.vue?vue&type=template&id=aff5c16c&scoped=true"
import script from "./ThemePreview.vue?vue&type=script&lang=js"
export * from "./ThemePreview.vue?vue&type=script&lang=js"
import style0 from "./ThemePreview.vue?vue&type=style&index=0&id=aff5c16c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff5c16c",
  null
  
)

export default component.exports